import React, {useContext, useEffect, useState} from "react";
import { Col, Row, Table, Button, Modal, Empty } from "antd";
import { Dropdown as DropdownSemantic, Icon } from "semantic-ui-react";
import { EvaluacionProyectosModel } from "./Modal/EvaluacionProyectosModel";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./styleCss.scss";
import { useInscribirHojaJurados } from "../../../hooks/useInscribirHojaJurados";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import apiMaestras from "../../../api/Maestras/api-maestras";
import moment from "moment";
import { openNotification } from "../../../utils/Notifactions";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import apiNotificaciones from "../../../api/Notificaciones/api-notificaciones";
import {TemplateContext} from "../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
// @ts-ignore
export default function EvaluacionProyectosList(props: any) {
  const [visible, setVisible] = useState(false);
   const context = useContext(TemplateContext);
  const [cantidadPáginas, setCantidadPáginas] = React.useState(10);
  const { proyectosSeguimiento, criteriosEvaluacion, consultarProyectoJuradoCriterioProyecto } = useInscribirHojaJurados();
  const [proyectoVisualizar, setProyectoVisualizar] = useState<any>();
  const [matchScreen, setMatchScreen] = useState<any>("");
  const [convocatorias, setConvocatorias] = useState([]);
  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const obtenerConvocatorias = async () => {
    try {
      const convocatorias = await apiMaestras.obtenerLineaConvocatoria();
      setConvocatorias(convocatorias);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    obtenerConvocatorias();
    consultarProyectoJuradoCriterioProyecto();
  }, []);
  useEffect(() => {
    var mobileQuery = window.matchMedia("(max-width: 768px)");
    mediaQueryCheck(mobileQuery);
    mobileQuery.addEventListener("change", mediaQueryCheck);
    return () => {
      mobileQuery.removeEventListener("change", mediaQueryCheck);
    };
  }, [matchScreen]);
  function mediaQueryCheck(inputQuery: any) {
    if (inputQuery.matches) {
      setMatchScreen(true);
    } else {
      setMatchScreen(false);
    }
  }
  const mostrarProyectos = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  const columns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 30,
      render: (data: any, data2: any, index: number) => {
        return <span>{index + 1}</span>;
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Nombre proyecto</span>,
      width: 160,
      render: (data: any) => {
        return <span>{`${data.proyecto.nombre_propuesta && data.proyecto.nombre_propuesta !== null ? data.proyecto.nombre_propuesta.substring(0, 24) : ''}...`}</span>;
      },
      fixed: matchScreen === true ? "" : "left",
    },
    {
      title: <span className="as_tbl_hd">Puntaje final</span>,
      render: (data: any) => {
        //
        if (data.proyecto.nota_final > 0) {
          return (
            <span className="font-color-00904C">
              {data.proyecto.nota_final}
            </span>
          );
        }
      },
      width: 70,
    },
    {
      title: <span className="as_tbl_hd">Codigo</span>,
      render: (data: any) => {
        return (
          <span className="font-color-00904C">{data.proyecto.radicado}</span>
        );
      },
      width: 60,
    },
    {
      title: <span className="as_tbl_hd">Linea </span>,
      render: (data: any) => {
        return <span>{`${data.proyecto.linea_convocatoria.substring(0, 24)}...`}</span>;
      },
      width: 120,
    },
    {
      title: <span className="as_tbl_hd">Categoria</span>,
      width: 100,
      render: (data: any) => {
        return <span>{`${data.proyecto.categoria_linea_convocatoria.substring(0, 24)}...`}</span>;
      },
    },
    {
      title: <span className="as_tbl_hd">Fecha act.</span>,
      // dataIndex: "fechaact",
      key: "4",
      width: 60,
      render: (data: any) => {
        if (data.proyecto.fecha_actualizacion) {
          return (
            <span>
              {moment(data.proyecto.fecha_actualizacion).format("DD/MM/YYYY")}
            </span>
          );
        }
        return <span></span>;
      },
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      fixed: context.device === "lg" ? "right" : false,
      width: 70,
      render: (datos: any) => (
        <>
          <div className="col-12 justify-content-center">
              <Button
                onClick={() => {
                  console.log(datos, 'datos')
                  setProyectoVisualizar(datos);
                  setVisible(true);
                }}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
          </div>
        </>
      ),
    },
  ];
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  }
  const [isTerm, setIsTerm] = useState(false);
  const onCancel = () => {
    setIsTerm(false);
    setVisible(false);
  };
  return (
    // @ts-ignore
    <div>
      <div style={{ background: "red" }}>
        <Modal
          // title="Evaluacion deProyectosList"
          centered
          visible={visible}
          onOk={() => setVisible(false)}
          onCancel={onCancel}
          width={1600}
          maskStyle={{
            background: "rgba(6, 100, 144,0.8)",
          }}
          className="eval_pro_model mt-2"
          footer={false}
        >
          <EvaluacionProyectosModel
            setVisible={setVisible}
            evalProyectoPage={"informacionProyectosList"}
            proyectosJurado={proyectoVisualizar}
            lineasconvocatorias={props.lineasConvocatorias}
            criterios={criteriosEvaluacion}
            jurado={props.jurado}
            consultarProyectoJuradoCriterioProyecto={
              consultarProyectoJuradoCriterioProyecto
            }
            isTerm={isTerm}
            setIsTerm={setIsTerm}
          />
        </Modal>

      </div>
      <div className="row mt-4">
        <div className="col-12 font-size-18px text-start font-family-Montserrat-Regular">
          <span className="font-family-Montserrat-SemiBold">
            A continuación se listarán los proyectos que se le asignaron.
          </span>{" "}
          Recuerde que debe completar todas las evaluaciones asignadas para
          poder enviarlas.
        </div>
        <div className="col-12 mt-3">
          <div className="row-shadow2 ms-1">
            <div className="row">
              <div className="col-12 justify-content-start text-start col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
                Proyectos a evaluar
              </div>
              <div className="col-12 col-md-6 pb-2">
                <div className="row g-2">
                  <div className="col-10 col-md-10  col-xl-10 col-xxl-11 d-flex justify-content-end align-content-center">
                    <span className="pe-4 col d-flex justify-content-md-end">
                      Total :{" "}
                      <span className="font-color-F28C02">
                        {proyectosSeguimiento.length}
                      </span>
                    </span>
                    <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                      Registros por página
                    </span>
                  </div>
                  <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                    <DropdownSemantic
                      fluid
                      className="select-registros-adminconvocatoria no-margin"
                      defaultValue={cantidadPáginas}
                      options={cantidadRegistros}
                      icon={<IconFlechareg/>
                    }
                      onChange={(e, { value }) => mostrarProyectos(e, value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <Table
                columns={columns}
                style={{ borderTop: "1px solid #C4C4C4" }}
                locale={{
                  emptyText: (
                    <Empty
                      description="No se han diligenciados datos para está sección"
                      style={{ padding: "50px" }}
                    />
                  ),
                }}
                pagination={{
                  position: ["bottomRight"],
                  itemRender: itemRenderTable,
                  pageSize: cantidadPáginas,
                }}
                dataSource={proyectosSeguimiento}
                scroll={{ x: "calc(590px + 50%)", y: 340 }}
                size="small"
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-dark" : "table-row-light"
                }
                bordered={false}
              />
            </div>
            {/*<div className="col-12 font-size-12px mt-4 font-family-Montserrat-Regular justify-content-flex-end">
              Debe completar todas las evaluaciones asignadas para poder
              envíarlas
              </div> */}
            <div className="col-12 justify-content-flex-end">
              {/* <Button className="button-blanco-radius me-2">
                  ATRÁS
              </Button>*/}
              {/*<Button
                className="button-azul-radius mb-0"
                onClick={async () => {
                  try {
                    let existeProyectoSinEvaluar = proyectosSeguimiento.filter(
                      (x: any) => x.proyecto.nota_final == null
                    );
                    if (existeProyectoSinEvaluar.length > 0) {
                      return openNotification({
                        titulo: "Error",
                        descripcion: "Faltan proyectos por evaluar",
                        placement: "bottomRight",
                      });
                    }
                    let payloadNotificacionAdmin = {
                      nombre_jurado: `${props.jurado.primer_nombre} ${props.jurado.segundo_nombre} ${props.jurado.primer_apellido} ${props.jurado.segundo_apellido}`,
                      tipo_notificacion: "evaluaciones",
                      remitente: props.jurado.numero_documento,
                    };
                    let postulaciones = proyectosSeguimiento.map((x: any) => {
                      return {
                        id_postulacion: x.proyecto.id_postulacion,
                      };
                    });
                    let paylaod = {
                      estado: "Evaluado",
                      postulaciones,
                    };
                    await apiParticipantes.actualizarEstadoPostulacion(paylaod);
                    await apiNotificaciones.enviarNotificacionAdministrador(
                      payloadNotificacionAdmin
                    );
                    consultarProyectoJuradoCriterioProyecto();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Enviar evaluaciones
              </Button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
